"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.supabase = void 0;

const supabase = client => {
  return {
    type: 'supabase',
    client,
    login: ({
      email,
      password
    }) => client.auth.login(email, password),
    logout: () => {
      client.auth.logout();
    },
    signup: ({
      email,
      password
    }) => client.auth.signup(email, password),
    getToken: async () => {
      const supabaseJson = localStorage.getItem('supabase.auth.token');
      const supabaseData = supabaseJson ? JSON.parse(supabaseJson) : null;
      return (supabaseData === null || supabaseData === void 0 ? void 0 : supabaseData.accessToken) || null;
    },
    getUserMetadata: async () => client.auth.user()
  };
};

exports.supabase = supabase;